<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              Saving New Agreement <strong>{{ doc_id }}</strong> {{ record.name }}, APN: {{ record.apn }}
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <form>
                <input type="hidden" v-model="record.id">
                <div class="form-group">
                  <label for="doc_id">Doc ID</label>
                  <input type="text" class="form-control" v-model="doc_id" id="doc_id">
                </div>
                <div class="form-group">
                  <label for="parent">Parent</label>
                  <v-select v-model="record.parent" :options="agreements"></v-select>
                </div>
                <div class="form-group">
                  <label for="file">Document</label>
                  <input class="form-control" id="file" type="file" accept=".pdf" @change="onFileChange">
                </div>
              </form>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button :disabled="ready == false" class="btn btn-success" @click="save()">
                Save
              </button>
              <button :disabled="ready == false" class="btn btn-default" @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import { mapState } from "vuex";
export default {
  name: "add-agreement-modal",
  props: ["record"],
  computed: mapState(["agreements"]),
  data() {
    return {
      document: {},
      doc_id: "",
      ready: true,
      parent: { value: "", text: "" }
    };
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.ready = true;
        return;
      }
      var reader = new FileReader();
      reader.onload = e => {
        this.document = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    reset() {
      this.parent = {};
    },
    save() {
      this.ready = false;
      let self = this;
      this.$store
        .dispatch("uploadAgreement", {
          parent: this.record.parent,
          doc_id: this.doc_id,
          document: this.document,
          record: this.record.id
        })
        .then(
          function() {
            self.$store.dispatch("loadRecord", self.record);
            self.$emit("close");
          },
          function() {
            self.ready = true;
          }
        );
    }
  }
};
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
